emojiPicker.$inject = ['$uibModal', '$translate', 'AlertingFactory'];
export function emojiPicker($uibModal, $translate, AlertingFactory) {
  return {
    restrict: 'A',
    link: function link($scope, element, attrs) {
      element.on('click', function() {
        $uibModal.open({
          animation: true,
          size: 'lg',
          template: require('./emojiPicker2.modal.html'),
          controller: 'emojiPicker2ModalController',
        }).result.then(result => {
          const message = result.emojiText + ' ' + $translate.instant('emoji_picker/copied_emoji_text');
          if (navigator.clipboard) {
            navigator.clipboard.writeText(result.emojiText)
              .then(() => AlertingFactory.success(message, { noTranslation: true }), 
                    () => AlertingFactory.error('bug/unexpected-error'));
          } else {
            AlertingFactory.error('error/feature_not_supported_in_browser');
          }
        });
      });
    }
  };
}
